import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Box } from '@mui/material'
import { useMergeState } from '../../../irmlib/src/hooks'
import { getUser } from '../../../redux/global'
import { useTranslation } from 'react-i18next'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { Autocomplete } from '../../../irmlib/src/components/FormControls'
import LocalNewDashboardData from './LocalNewDashboardData'

const AutoCompleteContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const DISTRICT_SELECT = 0
const BUILDING_SELECT = 1

const LocalNewDashboard = () => {
  const { t } = useTranslation()
  const selectBuildingRef = useRef(null)
  const selectDistrictRef = useRef(null)
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  const loggedInUserCountry = userval.country
  const localStorageDashboardDistrictKey = 'localDashboardDistrict'
  const localStorageDashboardBuildingKey = 'localDashboardBuilding'
  const localStorageDashboardPrevCountryKey = 'localPreviousCountry'
  const persistedCountry = JSON.parse(localStorage.getItem(localStorageDashboardPrevCountryKey))

  // Handled when user changes their country
  if (persistedCountry?.country !== getUser()?.country) {
    localStorage.setItem(localStorageDashboardPrevCountryKey, JSON.stringify({ country: getUser()?.country }))
    localStorage.setItem(localStorageDashboardDistrictKey, JSON.stringify({ district: null }))
    localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
  }

  const persistedDistrict = JSON.parse(localStorage.getItem(localStorageDashboardDistrictKey))
  const persistedBuilding = JSON.parse(localStorage.getItem(localStorageDashboardBuildingKey))
  
  const defaultDistrictSelectOption = {
    value: persistedDistrict?.district || loggedInUserDistrict,
    label: persistedDistrict?.district || loggedInUserDistrict,
  }

  const defaultBuildingSelectOption = {
    value: persistedBuilding?.building || '',
    label: persistedBuilding?.building || '',
  }

  const initialState = {
    selectedDistrict: '',
    districtsList: [defaultDistrictSelectOption],
    buildingsList: [defaultBuildingSelectOption],
    selectedBuilding: ''
  }

  const [state, setState, getState] = useMergeState(initialState)

  const formTemplate = [
    {
      label: 'templates.district',
      fieldKey: 'district',
      defaultValue: persistedDistrict?.district || loggedInUserDistrict,
      isRequired: true,
    },
    {
      label: 'templates.building',
      fieldKey: 'building',
      defaultValue: persistedBuilding?.building || getState()?.selectedBuilding,
      isRequired: true,
    },
  ]

  useEffect(() => {
    getDistricts(loggedInUserCountry)
    getPersistedFilters()
  }, [])

  const getPersistedFilters = () => {
    setState({ selectedDistrict: persistedDistrict?.district || loggedInUserDistrict, selectedBuilding: persistedBuilding?.building || '' })
  }

  const getDistricts = async (country = '') => {
    let collection
    if (country) {
      collection = await localGdeTransactions.getDistrictsByCountry(country)
    } else {
      collection = await localGdeTransactions.getDistricts()
    }
    const districtsList = []
    collection?.forEach((doc) => {
      districtsList.push({
        value: doc.data().districtName,
        label: doc.data().districtName,
      })
    })
    setState({ districtsList: districtsList })
  }

  const getSelectedDistrict = async(value) => {
    if (value !== undefined && value !== null) {
      if (getState()?.selectedDistrict && getState()?.selectedDistrict !== '' && value !== getState()?.selectedDistrict) {
        setState({ selectedBuilding: '' })
        selectBuildingRef.current.setValue('')
        localStorage.setItem(localStorageDashboardDistrictKey, JSON.stringify({ district: value }))
        localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
      }
      setState({ selectedDistrict: value })
      const buildingsData = await localGdeTransactions.getBuildingForDistrict(value)
      const buildings = []
      Object.keys(buildingsData).forEach((building) => {
        buildings.push({
          value: buildingsData[building],
          label: buildingsData[building]
        })
      })
      setState({ buildingsList: buildings })
    } else {
      setState({ buildingsList: [], selectedBuilding: '' })
      selectBuildingRef.current.setValue('')
      localStorage.setItem(localStorageDashboardDistrictKey, JSON.stringify({ district: null }))
      localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
    }
  }

  const getBuilding = (value) => {
    if (value !== undefined && value !== null) {
      setState({ selectedBuilding: value })
      localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: value }))
    } else {
      setState({ selectedBuilding: value })
      localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
    }
  }

  return (
    <>
      <Box sx={{ padding: 3 }}>
        <AutoCompleteContainer>
          <span style={{ width: '350px' }}>
            <Autocomplete
              heading={t('smartCatalog.smartCatalogLocalDashBoard')}
              id={'smartCatalogDashBoard_district'}
              options={state.districtsList}
              fieldTemplate={formTemplate[DISTRICT_SELECT]}
              onChange={getSelectedDistrict}
              clearIcon={null}
              ref={selectDistrictRef}
              noTranslateItems
            />
          </span>
          <span style={{ width: '270px', marginTop: '3.85rem', marginLeft: '2rem' }}>
            <Autocomplete
              label={t('templates.buildings')}
              id={'smartCatalogDashBoard_building'}
              options={state.buildingsList}
              fieldTemplate={formTemplate[BUILDING_SELECT]}
              onChange={getBuilding}
              disabled={state.buildingsList.length === 0}
              ref={selectBuildingRef}
              noTranslateItems
            />
          </span>
        </AutoCompleteContainer>
        {/* <SmartCatalogLandingPageData userSelectedDistrict={getState()?.selectedDistrict}/> */}
        <LocalNewDashboardData userSelectedDistrict={getState()?.selectedDistrict} userSelectedBuilding={getState()?.selectedBuilding}/>
      </Box>
    </>
  )
}

export default LocalNewDashboard
